"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ics = exports.yahoo = exports.office365 = exports.outlook = exports.google = exports.eventify = void 0;

var dayjs_1 = __importDefault(require("dayjs"));

var utc_1 = __importDefault(require("dayjs/plugin/utc"));

var query_string_1 = require("query-string");

var utils_1 = require("./utils");

dayjs_1["default"].extend(utc_1["default"]);

function formatTimes(_ref, dateTimeFormat) {
  var allDay = _ref.allDay,
      startUtc = _ref.startUtc,
      endUtc = _ref.endUtc;
  var format = utils_1.TimeFormats[allDay ? "allDay" : dateTimeFormat];
  return {
    start: startUtc.format(format),
    end: endUtc.format(format)
  };
}

var eventify = function eventify(event) {
  var start = event.start,
      end = event.end,
      duration = event.duration,
      rest = _objectWithoutProperties(event, ["start", "end", "duration"]);

  var startUtc = dayjs_1["default"](start).utc();
  var endUtc = end ? dayjs_1["default"](end).utc() : function () {
    if (event.allDay) {
      return startUtc.add(1, "day");
    }

    if (duration && duration.length == 2) {
      var value = Number(duration[0]);
      var unit = duration[1];
      return startUtc.add(value, unit);
    }

    return dayjs_1["default"]().utc();
  }();
  return _objectSpread(_objectSpread({}, rest), {}, {
    startUtc: startUtc,
    endUtc: endUtc
  });
};

exports.eventify = eventify;

var google = function google(calendarEvent) {
  var event = exports.eventify(calendarEvent);

  var _formatTimes = formatTimes(event, "dateTimeUTC"),
      start = _formatTimes.start,
      end = _formatTimes.end;

  var details = {
    action: "TEMPLATE",
    text: event.title,
    details: event.description,
    location: event.location,
    trp: event.busy,
    dates: start + "/" + end
  };

  if (event.guests && event.guests.length) {
    details.add = event.guests.join();
  }

  return "https://calendar.google.com/calendar/render?".concat(query_string_1.stringify(details));
};

exports.google = google;

var outlook = function outlook(calendarEvent) {
  var event = exports.eventify(calendarEvent);

  var _formatTimes2 = formatTimes(event, "dateTimeWithOffset"),
      start = _formatTimes2.start,
      end = _formatTimes2.end;

  var details = {
    path: "/calendar/action/compose",
    rru: "addevent",
    startdt: start,
    enddt: end,
    subject: event.title,
    body: event.description,
    location: event.location
  };
  return "https://outlook.live.com/calendar/0/deeplink/compose?".concat(query_string_1.stringify(details));
};

exports.outlook = outlook;

var office365 = function office365(calendarEvent) {
  var event = exports.eventify(calendarEvent);

  var _formatTimes3 = formatTimes(event, "dateTimeWithOffset"),
      start = _formatTimes3.start,
      end = _formatTimes3.end;

  var details = {
    path: "/calendar/action/compose",
    rru: "addevent",
    startdt: start,
    enddt: end,
    subject: event.title,
    body: event.description,
    location: event.location
  };
  return "https://outlook.office.com/calendar/0/deeplink/compose?".concat(query_string_1.stringify(details));
};

exports.office365 = office365;

var yahoo = function yahoo(calendarEvent) {
  var event = exports.eventify(calendarEvent);

  var _formatTimes4 = formatTimes(event, "dateTimeUTC"),
      start = _formatTimes4.start,
      end = _formatTimes4.end;

  var details = {
    v: 60,
    title: event.title,
    st: start,
    et: end,
    desc: event.description,
    in_loc: event.location
  };
  return "https://calendar.yahoo.com/?".concat(query_string_1.stringify(details));
};

exports.yahoo = yahoo;

var ics = function ics(calendarEvent) {
  var event = exports.eventify(calendarEvent);
  var formattedDescription = (event.description || "").replace(/,/gm, ",").replace(/;/gm, ";").replace(/\n/gm, "\\n").replace(/(\\n)[\s\t]+/gm, "\\n");
  var formattedLocation = (event.location || "").replace(/,/gm, ",").replace(/;/gm, ";").replace(/\n/gm, "\\n").replace(/(\\n)[\s\t]+/gm, "\\n");

  var _formatTimes5 = formatTimes(event, "dateTimeUTC"),
      start = _formatTimes5.start,
      end = _formatTimes5.end;

  var calendarChunks = [{
    key: "BEGIN",
    value: "VCALENDAR"
  }, {
    key: "VERSION",
    value: "2.0"
  }, {
    key: "BEGIN",
    value: "VEVENT"
  }, {
    key: "URL",
    value: event.url
  }, {
    key: "DTSTART",
    value: start
  }, {
    key: "DTEND",
    value: end
  }, {
    key: "SUMMARY",
    value: event.title
  }, {
    key: "DESCRIPTION",
    value: formattedDescription
  }, {
    key: "LOCATION",
    value: formattedLocation
  }, {
    key: "END",
    value: "VEVENT"
  }, {
    key: "END",
    value: "VCALENDAR"
  }];
  var calendarUrl = "";
  calendarChunks.forEach(function (chunk) {
    if (chunk.value) {
      calendarUrl += "".concat(chunk.key, ":").concat(encodeURIComponent("".concat(chunk.value, "\n")));
    }
  });
  return "data:text/calendar;charset=utf8,".concat(calendarUrl);
};

exports.ics = ics;